import {
  urlScanProduct,
  urlSelectCategory,
  urlSelectProduct,
} from "../../urls";
import { useCurrentPos } from "../../hooks/use-current-pos";
import { Link } from "react-router";
import { Button } from "@repo/ui/components/button";
import { OptionsGrid } from "../../components/options-grid";
import { useSendEvent } from "../../hooks/use-send-event";
import { ArrowLeft } from "lucide-react";

function SelectCategory() {
  const { club } = useCurrentPos();
  const sendEvent = useSendEvent();

  const categoriesWithProducts = club.productCategories.filter(
    (category) =>
      category.products.filter((product) => product.showOnPOS).length > 0
  );

  return (
    <div className="w-full flex-1 overflow-y-auto overflow-x-hidden py-4 min-h-0">
      <Button
        className="absolute left-0"
        asChild
        size="2xl"
        variant="pos-outline"
      >
        <Link to={urlScanProduct()} viewTransition>
          <ArrowLeft className="size-4" />
          Volver
        </Link>
      </Button>
      <div className="min-h-full flex items-center justify-center">
        <OptionsGrid>
          {categoriesWithProducts.map((category) => (
            <Button
              key={category.id}
              size="4xl"
              variant="pos-outline"
              onClick={() =>
                sendEvent("select_category", { categoryId: category.id })
              }
              asChild
            >
              <Link to={urlSelectProduct(category.id)} viewTransition>
                <div>
                  <div className="text-4xl! font-bold!">{category.name}</div>
                  <div className="text-lg! font-normal text-primary">
                    {category.description}
                  </div>
                </div>
              </Link>
            </Button>
          ))}
        </OptionsGrid>
      </div>
    </div>
  );
}

export const route = {
  path: urlSelectCategory(),
  element: <SelectCategory />,
  handle: {
    backLink: -1,
    title: "Selecciona la categoría del producto",
  },
};
